<template>
  <div class="flex-container bottom-bar">
    <price></price>
    <quantity-selector></quantity-selector>
    <div class="button-actions">
      <button class="btn btn-action" @click="gotoSummary" :class="{disabled : !validCart}" :disabled="!validCart">CONTINUE TO SUMMARY</button>
    </div>
  </div><!-- /.flex-container -->
</template>

<script>
import Price from "./Price"
import QuantitySelector from "./QuantitySelector"
import { mapState, mapActions } from "vuex"

export default {
  name: "Previewer",
  components: {
    Price,
    QuantitySelector,
  },
  computed: {
    ...mapState([
      "validCart"
    ])
  },
  methods: {
    ...mapActions(["set"]),
    gotoSummary() {
      if (this.validCart) {
        this.set({
          var: "selectedTab",
          val: 1
        })
      }
    }
  }
};
</script>
